import * as go from 'gojs';
import * as uuid from 'uuid';
import { getPointString, getSizeString } from '../../../../../utils/stringify-utils';
import { fontModelToGojsData } from '../../../utils/font-utils';
import { shadowModelToGojsData } from '../../../utils/shadow-utils';
import {
  LAYER_NAME_PROP,
  SHADOW_BLUR_PROP,
  SHADOW_COLOR_PROP,
  SHADOW_OFFSET_PROP,
  TEXT_FONT_PROP,
  Z_ORDER_PROP,
} from '../../common/config/common-prop-names';
import { startTextEditing } from '../../common/utils/start-text-editing';
import { StickyNodeCreateProps } from '../models/sticky-node-create-props';
import { StickyNode } from '../models/sticky-node.model';
import { bringToFront } from './../../../../../utils/bring-to-front-back/bring-to-front';

export const createStickyNode = (
  diagram: go.Diagram,
  {
    defaultBackground,
    defaultTextColor,
    width,
    height,
    categoryName,
    defaultShadow,
    defaultFont,
    location,
  }: StickyNodeCreateProps,
) => {
  const gojsShadow = shadowModelToGojsData(defaultShadow, SHADOW_BLUR_PROP, SHADOW_COLOR_PROP, SHADOW_OFFSET_PROP);

  const gojsFont = fontModelToGojsData(defaultFont, TEXT_FONT_PROP);

  const key = uuid.v4();

  diagram.commit(async () => {
    diagram.model.addNodeData(
      new StickyNode(
        key,
        categoryName,
        getSizeString(width, height),
        getPointString(location.x, location.y),
        defaultBackground,
        '',
        defaultTextColor,
        gojsShadow[SHADOW_COLOR_PROP] as string,
        gojsShadow[SHADOW_OFFSET_PROP] as string,
        gojsShadow[SHADOW_BLUR_PROP] as number,
        gojsFont[TEXT_FONT_PROP],
      ),
    );

    const node = diagram.findNodeForKey(key);
    if (node) {
      bringToFront(node, Z_ORDER_PROP, LAYER_NAME_PROP);
      await startTextEditing(diagram, node);
    }
  });

  return diagram.findNodeForKey(key);
};
